import {ApiActions} from "@touchnet/react-common";
import {call, put, select, takeEvery} from "redux-saga/effects";
import {LOG} from '@touchnet/js-utils';
import {actions} from "~/state/reducers/settings-reducer.ts";
import type {Effect, ForkEffect} from 'redux-saga/effects';
import SettingsService from "~/services/settings-service.ts";
import {cast} from "~/utils/fns.ts";
import Selectors from "~/state/selectors.ts";
import {ForbiddenError} from "~/types/error-type.ts";

export function* loadSettings(action: ReturnType<typeof actions.loadSettings>): IterableIterator<Effect> {
    yield put(ApiActions.beginApiCall(action.type));

    const cNum: string = cast<string>(yield select(Selectors.getCustomerNumber));
    const serverBase: string = cast<string>(yield select(Selectors.getServerBase));

    try {
        const settings = yield call(SettingsService.loadSettings, cNum, serverBase);

        if (settings) {
            yield put(actions.receiveSettings(settings));
        }
    } catch (error) {
        if (error instanceof ForbiddenError) {
            yield put(actions.setNoPermissions());
        }

        LOG.error('LOAD_SETTINGS: Error calling the api %o', [error]);
    }

    yield put(ApiActions.completeApiCall(action.type));
}

export default function* rootSaga(): IterableIterator<ForkEffect> {
    yield takeEvery(actions.loadSettings.type, loadSettings);
}